<div [innerHTML]="vm.errorMessage"></div>
